/**
 * @file carrier-sender.ts
 * @description Точка отправления перевозчика: модель и проверка готовности
 * (phase19.12).
 *
 * Настройка считается готовой по-разному в двух режимах передачи: когда мы
 * сами сдаём посылку в пункт — нужен код пункта; когда курьер забирает у нас —
 * нужен адрес склада (или хотя бы город/индекс для расчёта).
 */

import type { CarrierHandoverMode } from "./api-shop-carriers";

/** Подмножество формы настроек, которое относится к отправлению. */
export interface SenderFormValue {
  senderCityCode: string;
  senderPostalCode: string;
  senderAddress: string;
  senderPickupPointCode: string;
  handoverMode: CarrierHandoverMode;
}

/** Готова ли точка отправления для расчёта и передачи отгрузок. */
export function isSenderConfigured(value: SenderFormValue): boolean {
  if (value.handoverMode === "DROP_AT_PICKUP_POINT") {
    return value.senderPickupPointCode.trim() !== "";
  }
  return (
    value.senderAddress.trim() !== "" ||
    value.senderCityCode.trim() !== "" ||
    value.senderPostalCode.trim() !== ""
  );
}

/** Строка-итог под поиском адреса: то, что реально уедет в расчёт. */
export function senderSummary(
  value: SenderFormValue,
  cityName: string | null,
): string | null {
  const parts = [
    cityName ? `Город: ${cityName}` : null,
    value.senderCityCode.trim() ? `код СДЭК ${value.senderCityCode.trim()}` : null,
    value.senderPostalCode.trim() ? `индекс ${value.senderPostalCode.trim()}` : null,
  ].filter(Boolean);
  return parts.length > 0 ? parts.join(" · ") : null;
}
